import type {
  BooleanFilters,
  ClientCommentFilters,
  SortName,
} from '../generated';
import { ReactiveMap } from '../utils/ReactiveMap';
import { ReactiveState } from '../utils/ReactiveState';

/**
 * this value will be updated via `useFilteredComments` if an asset doesn't
 * support this sort name
 */
const DEFAULT_SORT_ORDER: SortName = 'TIMECODE';

const DEFAULT_BOOLEAN_FILTERS: BooleanFilters = {
  hasAnnotations: false,
  hasAttachments: false,
  isCompleted: false,
  isIncomplete: false,
  isUnreadByMe: false,
  mentionsMeOrReactedToMe: false,
};

const DEFAULT_FILTERS: ClientCommentFilters = {
  booleanFilters: DEFAULT_BOOLEAN_FILTERS,
  authors: [],
  hashtags: [],
  searchTerm: '',
  orderBy: DEFAULT_SORT_ORDER,
};

export const defaults = {
  DEFAULT_SORT_ORDER,
  DEFAULT_BOOLEAN_FILTERS,
  DEFAULT_FILTERS,
};

/** exported at the root of the package */
export const state = {
  /** current set of applied comment filters */
  filters: new ReactiveState<ClientCommentFilters, 'comment-filters'>(
    DEFAULT_FILTERS,
    'comment-filters'
  ),
  /** @client fields that decorate the `Comment` type */
  Comment: {
    /** Has a comment been deleted? */
    deleted: new ReactiveMap<string, boolean>(),
  },
};
